// 6 produits assurance — pages dédiées avec route /produit/:slug
// Template type Orus : H1 SEO + besoin + risques + garanties + CTA + Calendly + partenaires.

export const PRODUITS = {
  "rc-pro": {
    slug: "rc-pro",
    label: "Assurance RC Pro",
    overline: "Responsabilité Civile Professionnelle",
    h1: "Assurance Responsabilité Civile Professionnelle.",
    intro:
      "La RC Pro couvre les dommages corporels, matériels et immatériels que vous, vos salariés ou votre matériel pourriez causer à vos clients, fournisseurs ou tiers dans le cadre de votre activité.",
    risks: [
      "Dommages corporels causés à un client lors d'une prestation",
      "Erreur, faute, négligence ou omission professionnelle",
      "Dommages matériels causés sur le lieu d'intervention",
      "Préjudices financiers consécutifs à votre faute professionnelle",
    ],
    garanties: [
      "Frais de défense et recours",
      "Indemnisation des dommages aux tiers",
      "Protection juridique professionnelle",
      "Couverture monde entier selon options",
    ],
    seoTitle: "Assurance RC Pro · Devis personnalisé | OPTINA",
    seoDescription:
      "Responsabilité civile professionnelle : couverture sur mesure pour indépendants, TPE et PME. Devis en − de 24h par votre courtier indépendant.",
  },
  decennale: {
    slug: "decennale",
    label: "Assurance Décennale",
    overline: "Garantie décennale obligatoire",
    h1: "Assurance Décennale BTP.",
    intro:
      "Obligatoire pour tous les professionnels du bâtiment, la garantie décennale couvre pendant 10 ans les dommages qui compromettent la solidité de l'ouvrage ou le rendent impropre à sa destination.",
    risks: [
      "Effondrement partiel ou total de la structure",
      "Infiltrations, défauts d'étanchéité graves",
      "Affaissement, fissures structurelles",
      "Vices cachés mettant en cause la solidité",
    ],
    garanties: [
      "Couverture 10 ans après réception des travaux",
      "Garantie biennale (2 ans) pour les équipements",
      "Garantie de parfait achèvement (1 an)",
      "Attestation décennale fournie au client",
    ],
    seoTitle: "Assurance Décennale BTP · Artisans & Entreprises | OPTINA",
    seoDescription:
      "Garantie décennale pour artisans et entreprises du bâtiment. Maçons, plombiers, électriciens, couvreurs. Devis personnalisé en − de 24h.",
  },
  "local-professionnel": {
    slug: "local-professionnel",
    label: "Assurance Local Professionnel",
    overline: "Local commercial · Atelier · Boutique",
    h1: "Assurance Local Professionnel.",
    intro:
      "Multirisque pour votre local commercial, atelier ou boutique : protégez les murs, le mobilier, le matériel, les stocks et votre activité contre tous les sinistres du quotidien.",
    risks: [
      "Incendie, explosion, dégât des eaux",
      "Vol, vandalisme, dégradations",
      "Bris de glace et vitrines",
      "Catastrophes naturelles et événements climatiques",
    ],
    garanties: [
      "Multirisque local complet",
      "Perte d'exploitation après sinistre",
      "Responsabilité civile exploitation",
      "Garantie marchandises et stocks",
    ],
    seoTitle: "Assurance Local Professionnel · Multirisque | OPTINA",
    seoDescription:
      "Multirisque local commercial, atelier, boutique. Protection complète : incendie, vol, dégât des eaux, perte d'exploitation. Devis en − de 24h.",
  },
  bureaux: {
    slug: "bureaux",
    label: "Assurance Bureaux",
    overline: "Espaces de travail tertiaire",
    h1: "Assurance Bureaux & Espaces tertiaires.",
    intro:
      "Conçue pour les professions tertiaires : protégez vos bureaux, votre matériel informatique, vos données et votre activité de service face aux risques modernes.",
    risks: [
      "Incendie, dégât des eaux, vol",
      "Bris de matériel informatique et serveurs",
      "Perte de données et cyber-attaques",
      "Responsabilité envers les visiteurs et locataires voisins",
    ],
    garanties: [
      "Multirisque bureau et équipements",
      "Garantie cyber et perte de données",
      "Bris de matériel informatique",
      "RC exploitation et défense recours",
    ],
    seoTitle: "Assurance Bureaux · Cyber & multirisque | OPTINA",
    seoDescription:
      "Assurance bureaux pour activités tertiaires : multirisque, cyber, bris de matériel informatique. Courtier indépendant.",
  },
  "sante-tns": {
    slug: "sante-tns",
    label: "Mutuelle Santé TNS / Indépendant",
    overline: "Travailleurs Non Salariés",
    h1: "Mutuelle Santé TNS / Indépendant.",
    intro:
      "Conçue pour les Travailleurs Non Salariés (artisans, commerçants, libéraux, gérants majoritaires) : une couverture santé complète déductible fiscalement dans le cadre de la loi Madelin.",
    risks: [
      "Frais hospitaliers et chambre particulière",
      "Soins courants : consultations, pharmacie, optique, dentaire",
      "Médecines douces : ostéopathie, acupuncture, naturopathie",
      "Garanties spécifiques (orthodontie, prothèses, chirurgie réfractive)",
    ],
    garanties: [
      "Niveaux modulables selon votre budget",
      "Déduction fiscale loi Madelin",
      "Tiers payant généralisé",
      "Téléconsultation et services premium inclus",
    ],
    seoTitle: "Mutuelle Santé TNS Indépendant · Loi Madelin | OPTINA",
    seoDescription:
      "Mutuelle santé pour indépendants, artisans, commerçants, libéraux et gérants majoritaires. Déductible loi Madelin. Devis personnalisé.",
  },
  "prevoyance-tns": {
    slug: "prevoyance-tns",
    label: "Prévoyance TNS / Indépendant",
    overline: "Maintien de revenus",
    h1: "Prévoyance TNS / Indépendant.",
    intro:
      "Maintenez votre revenu et protégez votre famille en cas d'arrêt de travail, d'invalidité ou de décès. La prévoyance TNS est essentielle car les régimes obligatoires couvrent très peu les indépendants.",
    risks: [
      "Arrêt de travail temporaire (maladie ou accident)",
      "Invalidité partielle ou totale",
      "Décès et conséquences financières pour la famille",
      "Perte d'autonomie liée à l'âge ou à la maladie",
    ],
    garanties: [
      "Indemnités journalières en cas d'arrêt",
      "Rente d'invalidité",
      "Capital décès et rente conjoint/orphelin",
      "Déduction fiscale loi Madelin",
    ],
    seoTitle: "Prévoyance TNS Indépendant · Maintien de revenus | OPTINA",
    seoDescription:
      "Prévoyance pour indépendants : indemnités journalières, invalidité, décès. Déductible loi Madelin. Courtier indépendant.",
  },
  "flotte-auto": {
    slug: "flotte-auto",
    label: "Flotte Automobile",
    overline: "Flotte · Véhicules pro",
    h1: "Assurance Flotte Automobile.",
    intro:
      "Vous gérez plusieurs véhicules d'entreprise (utilitaires, voitures de fonction, VL, PL) ? L'assurance flotte simplifie votre gestion avec un contrat unique adapté à votre activité.",
    risks: [
      "Sinistres responsables et non responsables sur l'ensemble du parc",
      "Vol, incendie, bris de glace de vos véhicules",
      "Catastrophes naturelles, événements climatiques",
      "Responsabilité civile circulation",
    ],
    garanties: [
      "Contrat flotte unifié, gestion simplifiée",
      "Tous types de véhicules (VL, VU, PL, 2 roues)",
      "Assistance 0 km et véhicule de remplacement",
      "Protection juridique et défense recours",
    ],
    seoTitle: "Assurance Flotte Automobile · TPE/PME | OPTINA",
    seoDescription:
      "Assurance flotte automobile professionnelle : utilitaires, voitures, PL. Contrat unique, gestion simplifiée. Devis personnalisé.",
  },
  "sante-collective": {
    slug: "sante-collective",
    label: "Mutuelle Santé Collective",
    overline: "Mutuelle d'entreprise obligatoire",
    h1: "Mutuelle Santé Collective.",
    intro:
      "Depuis 2016, vous devez mettre en place une mutuelle d'entreprise pour vos salariés. Je négocie un contrat collectif adapté à votre branche professionnelle et à votre budget.",
    risks: [
      "Frais hospitaliers et chambre particulière des salariés",
      "Soins courants : pharmacie, optique, dentaire",
      "Maternité et garanties familiales",
      "Médecines douces et téléconsultation",
    ],
    garanties: [
      "Conformité ANI (Accord National Interprofessionnel)",
      "Adhésion conjoint et enfants en option",
      "Tiers payant généralisé",
      "Déduction des cotisations patronales",
    ],
    seoTitle: "Mutuelle Santé Collective · Entreprise | OPTINA",
    seoDescription:
      "Mutuelle santé collective obligatoire pour entreprises. Conformité ANI, branches pro. Devis personnalisé.",
  },
  auto: {
    slug: "auto",
    label: "Assurance Auto",
    overline: "Particuliers · Véhicule",
    h1: "Assurance Auto.",
    intro:
      "Voiture, moto, scooter : je compare les offres au tiers, intermédiaire et tous risques pour vous proposer la couverture qui convient à votre profil, votre kilométrage et votre stationnement.",
    risks: [
      "Sinistres responsables et non responsables",
      "Vol, incendie, bris de glace",
      "Catastrophes naturelles et événements climatiques",
      "Conducteur secondaire et conducteur novice",
    ],
    garanties: [
      "Au tiers, intermédiaire ou tous risques",
      "Assistance dépannage 0 km",
      "Véhicule de remplacement",
      "Protection juridique et défense recours",
    ],
    seoTitle: "Assurance Auto · Comparateur courtier | OPTINA",
    seoDescription:
      "Assurance auto : tiers, intermédiaire, tous risques. Comparateur courtier indépendant. Devis personnalisé en − de 24h.",
  },
  habitation: {
    slug: "habitation",
    label: "Assurance Habitation",
    overline: "Particuliers · Logement",
    h1: "Assurance Habitation.",
    intro:
      "Locataire ou propriétaire, résidence principale ou secondaire : je négocie une multirisque habitation adaptée à votre logement et à vos biens.",
    risks: [
      "Incendie, dégât des eaux, vol, vandalisme",
      "Catastrophes naturelles et événements climatiques",
      "Responsabilité civile vie privée",
      "Bris de glace, dégradations immobilières",
    ],
    garanties: [
      "Multirisque habitation complète",
      "Garantie objets de valeur (option)",
      "Garantie scolaire enfants",
      "Assistance 24/7 et relogement",
    ],
    seoTitle: "Assurance Habitation · Locataire & propriétaire | OPTINA",
    seoDescription:
      "Multirisque habitation : locataire, propriétaire, résidence secondaire. Courtier indépendant — devis personnalisé.",
  },
  sante: {
    slug: "sante",
    label: "Mutuelle Santé",
    overline: "Particuliers · Santé",
    h1: "Mutuelle Santé.",
    intro:
      "Une couverture santé adaptée à votre profil familial et à votre budget : soins courants, hospitalisation, optique, dentaire, médecines douces.",
    risks: [
      "Frais hospitaliers et chambre particulière",
      "Soins courants : consultations, pharmacie",
      "Optique, dentaire, audioprothèse",
      "Médecines douces et garanties spécifiques",
    ],
    garanties: [
      "Niveaux modulables 100% à 400% BR",
      "Tiers payant généralisé",
      "Téléconsultation incluse",
      "Adhésion conjoint et enfants",
    ],
    seoTitle: "Mutuelle Santé · Couverture sur mesure | OPTINA",
    seoDescription:
      "Mutuelle santé pour particuliers et familles. Niveaux modulables, courtier indépendant.",
  },
};

export const PRODUITS_LIST = Object.values(PRODUITS);

// Catégorisation Pro / Particulier pour le menu
export const PRODUITS_PRO_SLUGS = [
  "rc-pro",
  "decennale",
  "local-professionnel",
  "bureaux",
  "sante-tns",
  "prevoyance-tns",
  "flotte-auto",
  "sante-collective",
];
export const PRODUITS_PART_SLUGS = ["auto", "habitation", "sante"];
